<template>
  <span :class="['status-badge', statusClass]">{{ displayText }}</span>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    displayText() {
      const statusMap = {
        inprogress: 'In Progress',
        'In Progress': 'In Progress',
        pending: 'Pending',
        completed: 'Completed',
        failed: 'Failed',
        partial: 'Partial',
      }
      return statusMap[this.status?.toLowerCase()] || this.status
    },
    statusClass() {
      const status = this.status?.toLowerCase()
      return status === 'in progress' ? 'status-inprogress' : `status-${status}`
    },
  },
}
</script>

<style scoped>
.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize;
  white-space: nowrap;
  display: inline-block;
}

.status-inprogress,
.status-in.progress {
  background-color: #fff3cd;
  color: #856404;
}

.status-pending {
  background-color: #fff3e0;
  color: #e65100;
}

.status-completed {
  background-color: #d4edda;
  color: #155724;
}

.status-failed {
  background-color: #f8d7da;
  color: #721c24;
}

.status-partial {
  background-color: #e3f2fd;
  color: #0d47a1;
}
</style>
